import { createSelector } from 'reselect';

const selectPackagingType = (state: any) => state.PackagingType;


export const selectPackagingTypeCurrentItem = createSelector([selectPackagingType], (PackagingType) => PackagingType.current);

export const selectPackagingTypeListItems = createSelector([selectPackagingType], (PackagingType) => PackagingType.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectPackagingTypeListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPackagingTypeQueryItems = createSelector([selectPackagingType], (PackagingType) => PackagingType.query);

export const selectPackagingTypeCreatedItem = createSelector([selectPackagingType], (PackagingType) => PackagingType.create);

export const selectPackagingTypeUpdatedItem = createSelector([selectPackagingType], (PackagingType) => PackagingType.update);

export const selectPackagingTypeReadItem = createSelector([selectPackagingType], (PackagingType) => PackagingType.read);

export const selectPackagingTypeDeletedItem = createSelector([selectPackagingType], (PackagingType) => PackagingType.delete);

export const selectPackagingTypeSearchedItems = createSelector([selectPackagingType], (PackagingType) => PackagingType.search);

export const selectPackagingTypeItemsCount = createSelector([selectPackagingType], (PackagingType) => PackagingType.count);

export const selectPackagingTypeItemsFilter = createSelector([selectPackagingType], (PackagingType) => PackagingType.filter);